import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s talk about your project</h2>
                        </div>
                        <p>Tekrevol is ready to be your strategic partner. Engage with us and discuss your project complexity, allowing us to tailor our expertise perfectly to your brand's objectives. All our digital strategies, crafted with precision, ensure not just success, but a transformational journey toward your app's prominence in the market.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;